import { Avatar, Text, HStack, Badge, VStack, Card, CardBody, Checkbox } from '@chakra-ui/react'
import { UserAround } from '../../../../../api/api_hooks/user/useGetUsersAroundPoint'
import { useAuthedImage } from '../../../../../hooks/useAuthedImage'

interface CorrespondentCardProps {
  user: UserAround
  isSelected?: boolean
  onSelect: (user: UserAround) => void
}

const CorrespondentCard = ({
  user,
  isSelected = false,
  onSelect,
}: CorrespondentCardProps) => {
  // Avatar sous jeton — voir useAuthedImage.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const avatarSrc = useAuthedImage(user?.avatarFilePath)

  const handleClick = () => {
    onSelect(user)
  }

  return (
    <Card
      variant={isSelected ? 'filled' : 'outline'}
      bg={isSelected ? 'purple.50' : 'white'}
      borderColor={isSelected ? 'purple.500' : 'gray.200'}
      borderWidth={isSelected ? '2px' : '1px'}
      cursor="pointer"
      onClick={handleClick}
      _hover={{
        borderColor: 'purple.400',
        boxShadow: 'sm',
        transform: 'translateY(-2px)',
      }}
      transition="all 0.2s"
    >
      <CardBody p={4}>
        <HStack spacing={4} justify="space-between">
          <HStack spacing={3} flex={1}>
            <Avatar
              size="md"
              name={user.contactName}
              src={avatarSrc ?? undefined}
            />
            <VStack align="start" spacing={0} flex={1}>
              <HStack>
                <Text fontWeight="bold" fontSize="md" color="gray.800">
                  {user.contactName}
                </Text>
                {isSelected && (
                  <Badge colorScheme="purple" fontSize="xs">
                    Sélectionné
                  </Badge>
                )}
              </HStack>
              <Text fontSize="sm" color="gray.600">
                {user.specialty.name}
              </Text>
            </VStack>
          </HStack>
          <Checkbox
            isChecked={isSelected}
            pointerEvents="none"
            colorScheme="purple"
            size="lg"
            borderColor={isSelected ? 'purple.500' : 'gray.300'}
            aria-label="Sélection du correspondant"
          />
        </HStack>
      </CardBody>
    </Card>
  )
}

export default CorrespondentCard
